import { useMutation, useQueryClient } from '@tanstack/react-query';

import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { MutationConfig } from '@/lib/react-query';

export const updateLifecycle =
  (makeRequest: any) =>
  async ({
    lifecycleId,
    lpUi,
  }: {
    lifecycleId: string;
    lpUi: string;
  }): Promise<null> => {
    const { data, error } = await makeRequest({
      path: `/products/${lpUi}/lifecycle-status/${lifecycleId}`,
      method: 'put',
    });

    if (!data || error) {
      throw new Error(error);
    }

    return null;
  };

type UseUpdateLifecycleOptions = {
  config?: MutationConfig<ReturnType<typeof updateLifecycle>>;
};

export const useUpdateLifecycle = ({
  config,
}: UseUpdateLifecycleOptions = {}) => {
  const [, makeRequest] = useImperativeRequestWrapper('deviceV3');
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: (_data) => {
      queryClient.invalidateQueries({ queryKey: ['lifecycleStatus'] });
    },
    ...config,
    mutationFn: updateLifecycle(makeRequest),
  });
};
